import { Download, Lock, Shield, Zap } from 'lucide-react';

const BENEFITS = [
  {
    icon: Shield,
    title: 'No Redirects',
    description: 'QR codes point directly to your content — no middle tracking pages.',
  },
  {
    icon: Lock,
    title: 'Privacy Friendly',
    description: 'Generated directly in your browser whenever possible.',
  },
  {
    icon: Zap,
    title: 'No Sign-Up',
    description: 'Start instantly without creating an account.',
  },
  {
    icon: Download,
    title: 'Fast & Modern',
    description: 'Optimized for speed, clarity, and a clean download experience.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="border-t border-slate-200/80 bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl font-bold text-slate-900 sm:text-3xl">
          Why PixelUtility QR?
        </h2>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {BENEFITS.map(({ icon: Icon, title, description }) => (
            <article
              key={title}
              className="rounded-2xl bg-slate-50 p-6 ring-1 ring-slate-100 transition hover:shadow-md hover:shadow-slate-200/50"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 font-semibold text-slate-900">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
